/* ── Shared mutable state between Path scene and HexField ──
   Path.tsx writes slide + phase on every scroll update.
   HexField reads them to drive company logo particle formation. */

export const pathStore = {
  /** Index of the currently visible experience slide (0-based) */
  slide: -1,
  /** 0→1 progress of the current slide entering the viewport */
  phase: 0,
}
